import React, { useMemo } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Badge as BadgeIcon, LockOutlined as LockOutlinedIcon } from '@mui/icons-material';
import { useProductosMaterialContext } from 'context';
import { PROGRAMA_INICIO_NOMINA, puedeVerModuloNomina } from 'lib/seguridad/permisosPorModulo';
import { FP, PageHeader } from 'components/financepro';

export { PROGRAMA_INICIO_NOMINA };

const cardShellSx = {
  borderRadius: 2.5,
  bgcolor: FP.color.cardBg,
  boxShadow: FP.shadow.soft,
  border: `1px solid ${FP.color.border}`,
  overflow: 'hidden',
};

/**
 * Pantalla inicial del módulo Nómina.
 * Las pantallas operativas se irán agregando en `src/nomina` y `routesnom.js`.
 */
const InicioNomina = () => {
  const { controller } = useProductosMaterialContext();
  const { roleDetalles, roleWeb, nombreNegocio } = controller;

  const puedeLeer = useMemo(
    () => puedeVerModuloNomina(roleDetalles, roleWeb),
    [roleDetalles, roleWeb]
  );

  if (!puedeLeer) {
    return (
      <Box component="main" sx={{ minHeight: '100vh', bgcolor: FP.color.surface, p: { xs: 2, md: 3 } }}>
        <PageHeader title="Nómina" subtitle="Módulo de personal y pagos" />
        <Card sx={{ ...cardShellSx, maxWidth: 560, mx: 'auto', mt: 4 }}>
          <CardContent sx={{ textAlign: 'center', py: 5 }}>
            <LockOutlinedIcon sx={{ fontSize: 56, color: FP.color.textMuted, mb: 1 }} />
            <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: '1.05rem' }}>
              Acceso denegado
            </Typography>
            <Typography sx={{ color: FP.color.textSecondary, mt: 0.5, fontSize: '0.92rem' }}>
              No tienes permisos para acceder al módulo de nómina.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box component="main" sx={{ minHeight: '100vh', bgcolor: FP.color.surface, p: { xs: 2, md: 3 } }}>
      <PageHeader
        title="Nómina"
        subtitle={
          nombreNegocio
            ? `${nombreNegocio} · Personal, períodos y pagos`
            : 'Personal, períodos y pagos'
        }
      />
      <Card sx={{ ...cardShellSx, mt: 2 }}>
        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1.5 }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.4,
                bgcolor: FP.color.accentBlueSoft,
                color: FP.color.accentBlue,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <BadgeIcon sx={{ fontSize: 20 }} />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: '1rem' }}>
                Inicio de nómina
              </Typography>
              <Typography sx={{ color: FP.color.textSecondary, fontSize: '0.82rem' }}>
                Use el menú para abrir las pantallas de empleados, períodos y pagos.
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default InicioNomina;
